import { IconButton } from '@mui/material';
import React, { useContext } from 'react';
import stateContext from '../../Context/StateContext';

const Thickness = ({ activeThickness, setActiveThickness }) => {
    const globalState = useContext(stateContext);

    const thicknessContent = [
        { name: "Classic", thickness: "1.02mm", image: "thickness_classic.png", thicknessValue: 1.02 },
        { name: "Premium", thickness: "1.11mm", image: "thickness_premium.png", thicknessValue: 1.11 },
    ];

    const handleThicknessButtonClick = (thickness) => {
        globalState.setFontThickness(thickness);
        setActiveThickness(thickness);
    };

    return (
        <>
            <div className="tabpanel__content-boxes">
                {thicknessContent.map((item, index) => (
                    <div key={index} className={`tabpanel__content-box ${activeThickness === item.thicknessValue ? 'active' : ''}`}>
                        <IconButton className="inheritMuiIconButton" onClick={() => handleThicknessButtonClick(item.thicknessValue)}>
                            <span className="inheritMuiIconButton-container">
                                <span className="tabpanel__content-box-icon tabpanel__content-box-icon--48">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/${item.image}`}
                                        alt="placeholder"
                                        className="tabpanel__content-box-icon-img"
                                    />
                                </span>
                                <span className="tabpanel__content-box-label">
                                    {item.name}
                                    <br />
                                    <span className="almost-icon">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/almost-icon.png`} alt="Almost Icon" style={{ width: '14px' }} /> 
                                    </span> {item.thickness}
                                </span>
                            </span>
                        </IconButton>
                    </div>
                ))}
            </div>
        </>
    );
}

export default Thickness;
